<template>
  <div
    v-outside="closeOptions"
    :class="'dropdown ' + extraClass"
    @click="displayOptions"
  >
    <div 
      class="select-wrapper"
    >
      <div
        class="select" 
        type="text" 
        @input="filterOptions"
      >
        <input 
          type="button"
          class="title"
          :value="selected"
        >
      </div>
      <div 
        class="dropdown-click" 
      >
        <i 
          class="fa fa-caret-down" 
          :style="{transform: rotate}"
          aria-hidden="true"
        />
      </div>     
    </div>
    <div 
      v-if="rotate === 'rotate(180deg)'" 
      class="options" 
      :style="styleDrop"
    > 
      <div 
        v-for="item in searchedItems" 
        :key="item.id" 
        class="option" 
      > 
        <div 
          @click="$emit('save', item)"
        >
          <span class="title">
            {{ item.long || item.short }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {clickOutside} from '@/directives/clickOutside.ts';

export default {
  
  name: "DropdownClick",

  directives: {
      
    outside: clickOutside,
  },

  props: {

      directionUp: {
        type: Boolean,
        default: () => false
      },

      selected: {
        type: String, 
        default: () => ""
      },

      items: {
        
        type: Array,
        default: () => []
      },

      styleDrop: {
        type: Object,
        default: () => ({})
      },

      extraClass: {
        type: String,
        default: ""

      }

  },

  data(){
    
    return {

      searchQuery: "",

      rotate: 'rotate(0deg)',

      isTyping: true,

      isLoading: false,

      loaed: false,

      searchResults: []

    }

  },

  computed: {


    searchedItems(){
      if (this.type === "search"){

        return this.prepareItems(this.searchResults);
        
      } else {

        const data = this.prepareItems(this.items).filter(scr => scr.short && scr.short.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1);
        return data;
      }

    },

  },

  methods: {

    prepareItems(data){

      const newData = [];

      data.forEach((item) => {

        const newItem = {...item};

        let fieldShort = item.short || item.ticker || item.title || null;
        let fieldLong = item.long || item.name || null;

        if (fieldShort){

          newItem.short = fieldShort;

        }

        if(fieldLong){

          newItem.long = fieldLong;
        }

        if (!fieldShort){

          newItem.short = fieldLong;
          newItem.long = "";

        }
        newData.push(newItem);

      })

      return newData;

    },

    displayOptions(){

      if(this.rotate === 'rotate(0deg)'){

        this.rotate = 'rotate(180deg)';

      } else {

        this.rotate = 'rotate(0deg)';
      }

    },

    closeOptions(){

      this.rotate = 'rotate(0deg)'
    },

    
    openOptions(){

      this.rotate = 'rotate(180deg)';
    },


    filterOptions(e){
       
      this.isTyping = true;

      this.searchQuery = e.target.value;

    },
  
    
  },


}
</script>

<style scoped lang="sass">

.dropdown
  position: relative
  background: $color-bg-dropdown
  color: $color-bg-common



    
.select-wrapper
  height: 100%
  margin: auto
  display: flex
  align-items: center
  width: 160px
  width: 100%
  border-radius: 2px  

  .select
    // size: 450px
    display: flex
    align-items: center
    padding-left: 0.5em
    width: 100%
    border-radius: 2px
    border-right: 0
    border-top-right-radius: 0
    border-bottom-right-radius: 0
    cursor: default

    input
      background: transparent
      border: none !important
      color: inherit
      text-align: start
      padding-left: 0
      
        


.options
  position: absolute
  width: 100%
  margin-left: auto
  overflow-x: hidden
  max-height: 180px
  // position: absolute
  z-index: 999
  background-color: $color-text-common3
  border: 1px solid $color-text-slight
  color: $color-text-common2

  .option
    height: 30px
    margin-top: 3px
    cursor: pointer
    padding-right: $r * 0.6 
    padding-left: $r * 0.6

    > *
      height: 100%
      padding-top: 4px
      padding-bottom: 4px
      cursor: default

  .option:hover
    background: #84c4ff 


.dropdown-click
  display: table
  height: 50px
  border-left: 0
  border-radius: 2px
  border-top-left-radius: 0
  border-bottom-left-radius: 0
  width: 40px
  text-align: center
  transition: .3s

        
  > i 
      display: table-cell
      vertical-align: middle
      transition: 0.5s


.option-select
  width: 100%
  max-width: 450px
  border: 1px solid $color-text-light
  background: $color-bg-common
  border-radius: 2px
  color: $color-text-common2

  >input
    max-width: 400px

  .dropdown-click
    color: $color-text-light

  .options
    color: $color-text-common2
    top: 50px

.quantile-select
  width: 120px
  font-size: 0.9em
  background: transparent
  color: $color-text-second

  .select
    text-decoration: underline
    
  .options
    width: 120px






</style>